import React from 'react';
import {OutlinedInput} from "@mui/material";

const TextInput = (props) => {
    return (
            <OutlinedInput  sx={{
                flexGrow: 1,
                background: '#F9F9FB',
                ml: {md: 4, xs: 0},
                borderRadius: "25px",
                width: "100%",
                '&.MuiOutlinedInput-root.Mui-focused fieldset': {
                borderColor: "#974EC3",

            },

            }} {...props}/>
    );
};

export default TextInput;